import React from 'react'

function Booking() {
 return (
 <div>
 <div className="container-fluid bg-primary py-5 mb-5 hero-header">
 <div className="container">

   <div className="row justify-content-center">
 <div className="col-lg-10 text-center">
 <h1 className="display-3 text-white animated slideInDown">Booking</h1>
 <nav aria-label="breadcrumb">
 <ol className="breadcrumb justify-content-center">
 <li className="breadcrumb-item">
 <a href="/">Home</a>
 </li>
 <li
 className="breadcrumb-item text-white active"
 aria-current="page"
 >
 Booking
 </li>
 </ol>
 </nav>
 </div>
 </div>
 </div>
 </div>
 {/* Process Start */}
 <div className="container-xxl py-5">
 <div className="container">
 <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
 <h6 className="section-title bg-white text-center text-primary px-3">
 Processus
 </h6>
 <h1 className="mb-5">3 Étapes Faciles</h1>
 </div>
 <div className="row gy-5 gx-4 justify-content-center">
 <div
 className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
 data-wow-delay="0.1s"
 >
 <div className="position-relative border border-primary pt-5 pb-4 px-4">
 <div
 className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
 style={{ width: 100, height: 100 }}
 >
 <i className="fa fa-globe fa-3x text-white" />
 </div>
 <h5 className="mt-4">Choisissez Une Destination</h5>
 <hr className="w-25 mx-auto bg-primary mb-1" />
 <hr className="w-50 mx-auto bg-primary mt-0" />
 <p className="mb-0">
 Tempor erat elitr rebum clita dolor diam ipsum sit diam amet
 diam eos erat ipsum et lorem et sit sed stet lorem sit
 </p>
 </div>
 </div>
 <div
 className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
 data-wow-delay="0.3s"
 >
 <div className="position-relative border border-primary pt-5 pb-4 px-4">
 <div
 className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
 style={{ width: 100, height: 100 }}
 >
 <i className="fa fa-dollar-sign fa-3x text-white" />
 </div>
 <h5 className="mt-4">Payez En Ligne</h5>
 <hr className="w-25 mx-auto bg-primary mb-1" />
 <hr className="w-50 mx-auto bg-primary mt-0" />
 <p className="mb-0">
 Tempor erat elitr rebum clita dolor diam ipsum sit diam amet
 diam eos erat ipsum et lorem et sit sed stet lorem sit
 </p>
 </div>
 </div>
 <div
 className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
 data-wow-delay="0.5s"
 >
 <div className="position-relative border border-primary pt-5 pb-4 px-4">
 <div
 className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
 style={{ width: 100, height: 100 }}
 >
 <i className="fa fa-plane fa-3x text-white" />
 </div>
 <h5 className="mt-4">Voyagez Aujourd'hui</h5>
 <hr className="w-25 mx-auto bg-primary mb-1" />
 <hr className="w-50 mx-auto bg-primary mt-0" />
 <p className="mb-0">
 Tempor erat elitr rebum clita dolor diam ipsum sit diam amet
 diam eos erat ipsum et lorem et sit sed stet lorem sit
 </p>
 </div>
 </div>
 </div>
 </div>
 </div>
 {/* Process Start */}
 {/* Booking Start */}
 <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
 <div className="container">
 <div className="booking p-5">
 <div className="row g-5 align-items-center">
 <div className="col-md-6 text-white">
 <h6 className="text-white text-uppercase">Réservation</h6>
 <h1 className="text-white mb-4">Réservation En Ligne</h1>
 <p className="mb-4">
 Où que vos rêves vous mènent, nous veillerons à ce que chaque détail soit parfait.
Découvrez des destinations exclusives, comparez les meilleurs hôtels et réservez en toute confiance — tout en un seul endroit.

 </p>
 <p className="mb-4">
 Commencez votre prochaine aventure aujourd'hui.
 </p>
 <a className="btn btn-outline-light py-3 px-5 mt-2" href="">
 Lire Plus
 </a>
 </div>
 <div className="col-md-6">
 <h1 className="text-white mb-4">Réserver Un Circuit</h1>
 <form>
 <div className="row g-3">
 <div className="col-md-6">
 <div className="form-floating">
 <input
 type="text"
 className="form-control bg-transparent"
 id="name"
 placeholder="Votre Nom"
 />
 <label htmlFor="name">Votre Nom</label>
 </div>
 </div>
 <div className="col-md-6">
 <div className="form-floating">
 <input
 type="email"
 className="form-control bg-transparent"
 id="email"
 placeholder="Votre Email"
 />
 <label htmlFor="email">Votre Email</label>
 </div>
 </div>
 <div className="col-md-6">
 <div className="form-floating">
 <input
 type="datetime-local"
 className="form-control bg-transparent"
 id="datetime"
 placeholder="Date & Heure"
 />
 <label htmlFor="datetime">Date &amp; Heure</label>
 </div>
</div>

 <div className="col-md-6">
 <div className="form-floating">
 <select
 className="form-select bg-transparent"
 id="select1"
 >
 <option value={1}>Destination 1</option>
 <option value={2}>Destination 2</option>
 <option value={3}>Destination 3</option>
 </select>
 <label htmlFor="select1">Destination</label>
 </div>
 </div>
 <div className="col-12">
 <div className="form-floating">
 <textarea
 className="form-control bg-transparent"
 placeholder="Demande Spéciale"
 id="message"
 style={{ height: 100 }}
 defaultValue={""}
 />
 <label htmlFor="message">Demande Spéciale</label>
 </div>
 </div>
 <div className="col-12">
 <button
 className="btn btn-outline-light w-100 py-3"
 type="submit"
 >
 Réserver Maintenant
 </button>
 </div>
 </div>
 </form>
 </div>
 </div>
 </div>
 </div>
 </div>
 {/* Booking Start */}
 </div>
 )
}

export default Booking
